/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PPDDetail = {
    properties: {
        target_ppd: {
    type: 'number',
    isRequired: true,
    format: 'float',
},
        actual_work_hour: {
    type: 'number',
    isRequired: true,
    format: 'float',
},
    },
};